import { Yup } from '@frontman/utils';
import { CoverageCheckupState } from '../../store/step';

export const InsuranceDetailsSchema = Yup.string()
  .required('please select an option')
  .oneOf([
    'not_sure',
    'one_year_or_more',
    'last_twelve_months',
    'last_six_months',
  ]);

export function createInsuranceDetailsSchema(
  fieldName: keyof CoverageCheckupState
): Yup.ObjectSchema<any, any> {
  return Yup.object().shape({ [fieldName]: InsuranceDetailsSchema });
}
